var score = 1
var score1 = 1
function up(){
  if(score < 100 ){
    score ++;
  }
  document.getElementById("fproduct").value = score;
}

function down(){
  if(score > 1 ){
    score --;
  }
  document.getElementById("fproduct").value = score;
} 
function up1(){
  if(score1 < 100 ){
    score1 ++;
  }
  document.getElementById("sproduct").value = score1;
}

function down1(){
  if(score1 > 1 ){
    score1 --;
  }
  document.getElementById("sproduct").value = score1;
}    

$(document).ready(function() {
    var selling_plan_ids = $("#selling_plan_ids").val();
    var optiontype1;
    var optiontype2;
    var optiontype3;
    optiontype1 = $(".variant-option.checkboxdata0:checked").val();
    optiontype2 = $(".variant-option.checkboxdata1:checked").val();
    optiontype3 = $(".variant-option.checkboxdata2:checked").val();

    if (typeof optiontype3 !== "undefined") {
        var current_variant = optiontype1 + "/" + optiontype2 + "/" + optiontype3;
    } else if (typeof optiontype2 !== "undefined") {
        var current_variant = optiontype1 + "/" + optiontype2;
    } else {
        var current_variant = optiontype1;
    }

    var variantdata = $("#variantdata").val();
    var clickAction;
    const myArray = variantdata.split("\n");

    var processed_data = new Object();

    for (let i = 0; i < myArray.length; i++) {
        m = myArray[i].split(":");
        processed_data[m[0]] = m[1];
    }
    //console.log(optiontype1 + "/" + optiontype2 + "/" + optiontype3);
    $.each(processed_data, function(index, value) {

        if (current_variant == value) {
            //console.log("----------" + value);
            if (typeof window.renderBfcmProdPrice === 'function' && $("#v" + index).attr('data-price-cents')) {
              window.renderBfcmProdPrice(parseInt($("#v" + index).attr('data-price-cents'), 10));
            } else {
              $(".prod-price").html($("#v" + index).val());
            }
          
          if (typeof selling_plan_ids !== "undefined") {
            clickAction = "buttonClick(" + index + ","+selling_plan_ids+");return false;";
          } else {
            clickAction = "buttonClick(" + index + ");return false;";
          }
         var carouselElement = document.querySelector('.product-slider')
          var carousel = (carouselElement && carouselElement.getAttribute('data-flickity')) ? new Flickity(carouselElement, JSON.parse(carouselElement.getAttribute('data-flickity'))) : null;
          var slideIndex = 0;
          $('.thumbnail-imgs').each(function(){
            if($(this).attr('data-variant') == index){
              slideIndex = $(this).index();
            }
          })
           if (carousel) { carousel.select(slideIndex); }           
            $('#add-to-cart').attr('onClick', clickAction);
        }
    });


    $(".variant-option.checkboxdata0") // select the radio by its id
        .change(function() { // bind a function to the change event
            if ($(this).is(":checked")) { // check if the radio is checked
                var optiontype1 = $(this).val(); // retrieve the value
                optiontype2 = $(".variant-option.checkboxdata1:checked").val();
                optiontype3 = $(".variant-option.checkboxdata2:checked").val();

                if (typeof optiontype3 !== "undefined") {
                    current_variant = optiontype1 + "/" + optiontype2 + "/" + optiontype3;
                } else if (typeof optiontype2 !== "undefined") {
                    current_variant = optiontype1 + "/" + optiontype2;
                } else {
                    current_variant = optiontype1;
                }
                console.log("First - "+ optiontype1 + "/" + optiontype2 + "/" + optiontype3);

                $('.typex1 label.variant-lablel').hide();
                $('.typex1 input.variant-option').hide();
             

                var firstflag = true;
                $.each(processed_data, function(index, value) {

                    if (typeof value !== "undefined") {
                        var fistsplit = value.split("/");
                    } else {
                        var fistsplit = "";
                    }
                    
                  if (typeof optiontype2 !== "undefined") {
                    var typenamex = $(".checkboxdata1").attr("name");
                    if (optiontype1 == fistsplit[0]) {                      
                        $('label[for="ProductSelect-option-' + typenamex + '-' + fistsplit[1].replaceAll(' ', '') + '"]').show();                        
                        if (firstflag) {
                            $('.typex1 input:checked').prop('checked', false);
                            $("#ProductSelect-option-" + typenamex + "-" + fistsplit[1].replaceAll(' ', '')).click();
                            //console.warn("#ProductSelect-option-"+typenamex+"-"+fistsplit[1].replaceAll(' ','')); 
                            firstflag = false;
                        }
                    }
                  }

                    if (current_variant == value) {
                        //console.log("----------" + value);
                        if (typeof window.renderBfcmProdPrice === 'function' && $("#v" + index).attr('data-price-cents')) {
                            window.renderBfcmProdPrice(parseInt($("#v" + index).attr('data-price-cents'), 10));
                        } else {
                            $(".prod-price").html($("#v" + index).val());
                        }
                        if (typeof selling_plan_ids !== "undefined") {
                          clickAction = "buttonClick(" + index + ","+selling_plan_ids+");return false;";
                        } else {
                          clickAction = "buttonClick(" + index + ");return false;";
                        }
                       var carouselElement = document.querySelector('.product-slider')
          var carousel = (carouselElement && carouselElement.getAttribute('data-flickity')) ? new Flickity(carouselElement, JSON.parse(carouselElement.getAttribute('data-flickity'))) : null;
          var slideIndex = 0;
          $('.thumbnail-imgs').each(function(){
            if($(this).attr('data-variant') == index){
              slideIndex = $(this).index();
            }
          })
           if (carousel) { carousel.select(slideIndex); }   
                        $('#add-to-cart').attr('onClick', clickAction);
                    }
                });

            }
        });

    $(".variant-option.checkboxdata1") // select the radio by its id
        .change(function() { // bind a function to the change event
            if ($(this).is(":checked")) { // check if the radio is checked
                var optiontype2 = $(this).val(); // retrieve the value

                if (typeof optiontype2 == "undefined") {
                  optiontype2 = $(".variant-option.checkboxdata1:checked").val();
                }
              
                optiontype1 = $(".variant-option.checkboxdata0:checked").val();
                optiontype3 = $(".variant-option.checkboxdata2:checked").val();
                  console.log(optiontype3);
                if (typeof optiontype3 !== "undefined") {
                    current_variant = optiontype1 + "/" + optiontype2 + "/" + optiontype3;
                } else if (typeof optiontype2 !== "undefined") {
                    current_variant = optiontype1 + "/" + optiontype2;
                } else {
                    current_variant = optiontype1;
                }

                console.log("Second - "+ optiontype1 + "/" + optiontype2 + "/" + optiontype3);

                var secondflag = true;
                $('.typex2 label.variant-lablel').hide();
                $('.typex2 input.variant-option').hide();

                $.each(processed_data, function(index, value) {


                    if (typeof value !== "undefined") {
                        var fistsplit = value.split("/");
                    } else {
                        var fistsplit = "";
                    }

                  if (typeof optiontype3 !== "undefined") {
                  var typenamex = $(".checkboxdata2").attr("name");
                  if (typeof fistsplit[2] !== "undefined") {
                    if (optiontype1 == fistsplit[0]) {
                        if (optiontype2 == fistsplit[1]) {                            
                            $('label[for="ProductSelect-option-' + typenamex + '-' + fistsplit[2].replaceAll(' ', '') + '"]').show();
                            
                            if (secondflag) {
                                $('.typex2 input:checked').prop('checked', false);
                                $("#ProductSelect-option-" + typenamex + "-" + fistsplit[2].replaceAll(' ', '')).click();
                                secondflag = false;
                            }
                        } 
                    }
                  }
                  }


                    if (current_variant == value) {
                       // console.log("----------" + value);
                        if (typeof window.renderBfcmProdPrice === 'function' && $("#v" + index).attr('data-price-cents')) {
                            window.renderBfcmProdPrice(parseInt($("#v" + index).attr('data-price-cents'), 10));
                        } else {
                            $(".prod-price").html($("#v" + index).val());
                        }
                        if (typeof selling_plan_ids !== "undefined") {
                          clickAction = "buttonClick(" + index + ","+selling_plan_ids+");return false;";
                        } else {
                          clickAction = "buttonClick(" + index + ");return false;";
                        }
                      var carouselElement = document.querySelector('.product-slider')
          var carousel = (carouselElement && carouselElement.getAttribute('data-flickity')) ? new Flickity(carouselElement, JSON.parse(carouselElement.getAttribute('data-flickity'))) : null;
          var slideIndex = 0;
          $('.thumbnail-imgs').each(function(){
            if($(this).attr('data-variant') == index){
              slideIndex = $(this).index();
            }
          })
           if (carousel) { carousel.select(slideIndex); }   
                        $('#add-to-cart').attr('onClick', clickAction);
                    }
                });

            }
        });

    $(".variant-option.checkboxdata2") // select the radio by its id
        .change(function() { // bind a function to the change event
            if ($(this).is(":checked")) { // check if the radio is checked
                // debugger;
                var optiontype3 = $(this).val(); // retrieve the value

                if (typeof optiontype3 == "undefined") {
                optiontype3 = $(".variant-option.checkboxdata2:checked").val();
                }
                optiontype2 = $(".variant-option.checkboxdata1:checked").val();
                optiontype1 = $(".variant-option.checkboxdata0:checked").val();

                console.log("Third - " + optiontype1 + "/" + optiontype2 + "/" + optiontype3);
                current_variant = optiontype1 + "/" + optiontype2 + "/" + optiontype3;

                $.each(processed_data, function(index, value) {
                    if (current_variant == value) {
                        //console.log("----------" + value);
                        if (typeof window.renderBfcmProdPrice === 'function' && $("#v" + index).attr('data-price-cents')) {
                            window.renderBfcmProdPrice(parseInt($("#v" + index).attr('data-price-cents'), 10));
                        } else {
                            $(".prod-price").html($("#v" + index).val());
                        }
                        if (typeof selling_plan_ids !== "undefined") {
                          clickAction = "buttonClick(" + index + ","+selling_plan_ids+");return false;";
                        } else {
                          clickAction = "buttonClick(" + index + ");return false;";
                          $('.hidden-variant').val(index);
                        }
                       var carouselElement = document.querySelector('.product-slider')
          var carousel = (carouselElement && carouselElement.getAttribute('data-flickity')) ? new Flickity(carouselElement, JSON.parse(carouselElement.getAttribute('data-flickity'))) : null;
          var slideIndex = 0;
          $('.thumbnail-imgs').each(function(){
            if($(this).attr('data-variant') == index){
              slideIndex = $(this).index();
            }
          })
           if (carousel) { carousel.select(slideIndex); }   
                        $('#add-to-cart').attr('onClick', clickAction);
                    }
                });

            }
        });

$('.variant-option:checked').eq(0).trigger('change')
});
        
